import { useTranslationsContext } from '../context/TranslationsContext'

export const InsuranceParamsType = {
    ObsoleteParams: 0,
    Basic: 1,
    AddOn: 2,
    Poleas: 3,
    Poleas2: 4,
    StockBefore: 5,
    StockAfter: 6,
}
export type InsuranceParamsType = typeof InsuranceParamsType[keyof typeof InsuranceParamsType]

type PossibleTypes = InsuranceParamsType | undefined

export const InsuranceParamsTypes: [PossibleTypes, string, string, string, string, string][] = [
    [InsuranceParamsType.ObsoleteParams, 'Standardní pojištění', 'SP', 'primary.50', 'primary.500', 'insuranceParamsType.obsoleteParams'],
    [InsuranceParamsType.Basic, 'Standardní pojištění', 'SP', 'primary.50', 'primary.500', 'insuranceParamsType.basic'],
    [InsuranceParamsType.AddOn, 'Doplňkové pojištění', 'DP', 'blue.50', 'blue.400', 'insuranceParamsType.addOn'],
    [InsuranceParamsType.Poleas, 'Poleasing 1', 'P1', 'orange.50', 'orange.500', 'insuranceParamsType.poleas'],
    [InsuranceParamsType.Poleas2, 'Poleasing 2', 'P2', 'orange.50', 'orange.500', 'insuranceParamsType.poleas2'],
    [InsuranceParamsType.StockBefore, 'Skladové pojištění BEFORE', 'SB', 'teal.50', 'teal.600', 'insuranceParamsType.stockBefore'],
    [InsuranceParamsType.StockAfter, 'Skladové pojištění AFTER', 'SA', 'teal.50', 'teal.600', 'insuranceParamsType.stockAfter'],
]

export const getInsuranceParamsTypeName = (type: PossibleTypes) => {
    return type !== undefined ? InsuranceParamsTypes.find(([key]) => key === type)?.[1] : undefined
}

export const getInsuranceParamsTypeShortName = (type: PossibleTypes) => {
    return type !== undefined ? InsuranceParamsTypes.find(([key]) => key === type)?.[2] : undefined
}

export const getInsuranceParamsTypeColor = (type: PossibleTypes) => {
    return type !== undefined ? [InsuranceParamsTypes.find(([key]) => key === type)?.[3], InsuranceParamsTypes.find(([key]) => key === type)?.[4]] : undefined
}

export const getInsuranceParamsTypeTranslationKey = (type: PossibleTypes) => {
    return type !== undefined ? InsuranceParamsTypes.find(([key]) => key === type)?.[5] : undefined
}

// convert getInsuranceParamsTypeName into hook
export const useInsuranceParamsTypeName = () => {

    const { translate } = useTranslationsContext()

    const getTranslatedType = (type: PossibleTypes) => {
        return translate(getInsuranceParamsTypeTranslationKey(type) ?? '', getInsuranceParamsTypeName(type))
    }

    return getTranslatedType
}